import {
  TriggeredMessageViewChannelsConfigFragment,
  MessagingCampaignEngagementChannelsConfigFragment,
  UpdateTriggeredMessageMutationVariables,
} from '@occc/graphql';

import { PushNotificationConfig } from './push-notification-config.schema';
import { SmsNotificationConfig } from './sms-notification-config.schema';
import { EngagementChannelConfigFormValues } from './engagement-channel-config.schema';

const defaultFormValues: EngagementChannelConfigFormValues = {
  smsConfig: {
    isEnabled: true,
    body: '',
  },
};

export const getFormValues = (
  channelsConfig?:
    | TriggeredMessageViewChannelsConfigFragment
    | MessagingCampaignEngagementChannelsConfigFragment
    | null,
): EngagementChannelConfigFormValues => {
  const smsConfig: SmsNotificationConfig = channelsConfig?.smsConfig?.enabled
    ? {
        isEnabled: true,
        body: channelsConfig?.smsConfig?.body,
      }
    : { isEnabled: false };

  const pushNotificationConfig: PushNotificationConfig = channelsConfig?.pushNotificationConfig
    ?.enabled
    ? {
        isEnabled: true,
        notificationTitle:
          channelsConfig?.pushNotificationConfig?.template.notification.title ?? '',
        notificationBody: channelsConfig?.pushNotificationConfig?.template.notification.body,
        url: channelsConfig?.pushNotificationConfig?.template?.data?.url,
      }
    : { isEnabled: false };

  const values: EngagementChannelConfigFormValues =
    channelsConfig?.smsConfig || channelsConfig?.pushNotificationConfig
      ? { smsConfig, pushNotificationConfig }
      : defaultFormValues;

  return values;
};

type UpdateChannelsConfigInput = NonNullable<
  UpdateTriggeredMessageMutationVariables['input']['channelsConfig']
>;

export const getUpdateChannelsConfigInput = (
  formValues: EngagementChannelConfigFormValues,
): UpdateChannelsConfigInput => {
  return {
    smsConfig: formValues.smsConfig?.isEnabled
      ? {
          enabled: true,
          body: formValues.smsConfig.body,
        }
      : null,
    pushNotificationConfig: formValues.pushNotificationConfig?.isEnabled
      ? {
          enabled: true,
          template: {
            notification: {
              title: formValues.pushNotificationConfig.notificationTitle || '',
              body: formValues.pushNotificationConfig.notificationBody || '',
            },
            data: {
              url: formValues.pushNotificationConfig.url,
            },
          },
        }
      : null,
  };
};
